// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__8HMPP","header":"ClearentDisclaimer_header__1KuMZ","inner":"ClearentDisclaimer_inner___E9HW"};